import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from 'react-toastify'
import axios from "axios";
import { useStripe, CardCvcElement, useElements } from "@stripe/react-stripe-js";
import { Country, State, City } from "country-state-city";
import { CardElement } from "@stripe/react-stripe-js";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AuthContext } from "../helpers/AuthContext";
import PageHeaderWithBreadcrumbs from "../components/PageHeaderWithBreadcrumbs";
import LoopIcon from '@mui/icons-material/Loop';
import Select from "react-select";

const CompleteRegistration = ({ paymentFailedStatus }) => {
  let { instanceUniqueId } = useParams();
  const { setAuthState } = useContext(AuthContext);
  const [cvcError, setCvcError] = useState(null);
  const [cardInfo, setCardInfo] = useState({
    name: "",
    expiry: "",
    number: "",
    address: {
      line: "",
      postalCode: "",
    },
  });
  const [locations, setLocations] = useState({ countries: "", states: "", cities: "" });
  const [selectedLocation, setSelectedLocation] = useState({ country: {}, city: {}, state: {} });
  const [loadingAnimation, setLoadingAnimation] = useState({active: false, message: "Loading"})
  const [buttonDisable, setButtonDisable] = useState(false)
  let history = useHistory();
  const disableSubmissionButton = useRef();
  const stripe = useStripe();
  const elements = useElements();
  const card = useRef();
  const { authState } = useContext(AuthContext);
 
  const initialValues = {
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    password: "",
    name: "",
    address: "",
    businessName: ""
  };

  const validationSchema = Yup.object().shape({
    // Payment details
    name: Yup.string().min(3).max(24).required("You must provide a valid cardholder name between 3 to 24 characters."),
    address: Yup.string().min(3).max(46).required("You must provide an address between 3 to 46 characters."),
    businessName: Yup.string("You must provide a business name that doesn't exceed 100 characters.").max(100, "You must provide a business name that doesn't exceed 100 characters.")
  });

  function parseForSelect(arr) {
    return arr.map((item) => ({
      label: item.name,
      value: item.isoCode ? item.isoCode : item.name,
    }));
  }

  function handleSelectCountry(country) {
    const states = State.getStatesOfCountry(country.value);
    setSelectedLocation((prev) => {
      return { ...prev, country };
    });

    setLocations((prev) => ({ ...prev, states: parseForSelect(states) }));
  }

    function handleChangePostalCode(e) {
        const { value } = e.target;
        setCardInfo((prev) => {
        return { ...prev, address: { ...prev.address, postalCode: value } };
        });
     }

  function handleSelectState(state) {
    const cities = City.getCitiesOfState(selectedLocation.country.value, state.value);
    setSelectedLocation((prev) => {
      return { ...prev, state };
    });

    setLocations((prev) => ({ ...prev, cities: parseForSelect(cities) }));
  }

  function handleSelectCity(city) {
    setSelectedLocation((prev) => {
      return { ...prev, city };
    });
  }

  const onSubmit = (data) => {

    setButtonDisable(true)
    const address = cardInfo.address;
    const billingDetails = {
      name: data.name,
      address: {
        country: selectedLocation.country.value,
        state: selectedLocation.state.value,
        city: selectedLocation.city.value,
        line1: data.address,
        postal_code: address.postalCode,
      },
      email: data.email,
      phone: data.phone_number,
    };
    // User has been successfully created 
    stripe.createToken(elements.getElement(CardElement))
    .then((result) => {
      // Verify that the card is valid
      if (result.error) {
        setCvcError(result.error.message);
        toast.error(cvcError, {
          toastId: 3
        })
        setButtonDisable(false)
        setLoadingAnimation({active: false, message: null})
      } else {
        setLoadingAnimation({active: true, message: `Verifying payment method.`})
        // Card is verified, create payment method
        stripe
        .createPaymentMethod({
          type: "card",
          billing_details: billingDetails,
          card: elements.getElement(CardElement),
        }).then((paymentMethodResponse) => {  
          // Payment method retrieved, create a payments intents     
          axios.post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/confirm-card-setup`, { 
            userId: authState.id,
            paymentMethod: paymentMethodResponse.paymentMethod,
            createStripeCustomerAccount: true,
            businessName: data.businessName
          }).then((paymentStatus) => {
            if(paymentStatus.data.cardPaymentSuccessful == true){
              setLoadingAnimation({active: true, message: `Payment method has been validated`})
              toast.success("The card is valid.", {
                toastId: 2
              })
              const activateInstance = new FormData()
              activateInstance.append('instanceUniqueId', instanceUniqueId) 
              activateInstance.append('stripeUserId', paymentStatus.data.StripeUserId)
              var meggedObj = {}
              // add the form key/value pairs
              for (var pair of activateInstance.entries()) {
                meggedObj[pair[0]] = pair[1];
              }
              axios
              .post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/update-core/active-status`, meggedObj, {
                headers: { 
                  accessToken: localStorage.getItem("accessToken"),
                }
              }).then(activeResponse => {
                history.go("/instance/" + instanceUniqueId + "/get-code")
              })
            } else if (paymentStatus.data.cardPaymentSuccessful == false) {
              toast.error("The card was not valid. Please retry.", {
                toastId: 1
              })
              setLoadingAnimation({active: false, message: null})
              setButtonDisable(false)
            }
          }) // Payment Intents Response
        }) // PaymentMethod Response
      } // Verify card is valid
    }) // After token
  }

  useEffect(() => {
    const allCountry = Country.getAllCountries();

    setLocations((prev) => {
      return { ...prev, countries: parseForSelect(allCountry) };
    });
  }, []);

  return (
    <div>
      <ToastContainer/>
      <div className="rightSide">
        <div className="options-container">
          <div className="options-inner-container">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          
          
          <Form className="registration-form-container fade-in-effect-usability">
          {paymentFailedStatus == false ?
          <PageHeaderWithBreadcrumbs title="Get code" breadcrumb="Get code"/>
          :
          <PageHeaderWithBreadcrumbs title="New payment method" breadcrumb="New payment method"/>
          }

          <div className="paymentForm">
            { loadingAnimation.active == true ?
              <div className="loading-animation fade-in-effect-usability" style={{position: "absolute", borderRadius: "15px"}}>
                <span className="loading-label"><span className="loading-message">{loadingAnimation.message}</span><LoopIcon className="rotating"/></span>
              </div>
            : 
              ""
            }
            {paymentFailedStatus == false ?
            <>
              <span className="instance-badge-step-four">Step #4</span>
              <h2>Add a payment method.</h2>
              <p>In order to add your support agent core to your website or application, you must add a payment method.</p>
            </>
            : 
            <>
              <h2>Please add a new payment method.</h2>
              <p>Unfortuatnely, the default payment method attached to your live core encountered an issue when processing payment. Please add a new payment to your live core to continue using Elite Core on your website or application.</p>
            </>
            }
            <div className="options-row">
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Cardholder name</label>
                  <ErrorMessage name="name" component="span" />
                  <Field
                  autocomplete="off"
                  id="inputCreatePost"
                  name="name"
                  type="text"
                  placeholder="John Doe"
                  />
                </div>
              </div>
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Address</label>
                  <ErrorMessage name="address" component="span" />
                  <Field
                    type="text"
                    name="address"
                    placeholder="Enter the address associated with your card."
                  />
                </div>
              </div>
            </div>
            
            <div className="options-row">
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Country</label>
                  <Select
                      className="select-container-v2"
                      isSearchable={false}
                      name="country"
                      value={selectedLocation.country !== null ? selectedLocation.country : "Type to search for your country"}
                      options={locations.countries}
                      onChange={handleSelectCountry}
                    />
                </div>
              </div>
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>State or province</label>
                  <Select
                      className="select-container-v2"
                      isSearchable={false}
                      name="state"
                      value={selectedLocation.state}
                      options={locations.states}
                      onChange={handleSelectState}
                    />
                </div>
              </div>
            </div>

            <div className="options-row">
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>City</label>
                  <Select
                    className="select-container-v2"
                    isSearchable={false}
                    name="city"
                    value={selectedLocation.city}
                    options={locations.cities}
                    onChange={handleSelectCity}
                  />
                </div>
              </div>
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Postal code</label>
                  <input
                    onChange={handleChangePostalCode}
                    type="text"
                    name="postalCode"
                    placeholder="Enter postal code"
                  />
                </div>
              </div>
            </div>     


            <div className="options-row">
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Business name</label>
                  <ErrorMessage name="businessName" component="span" />
                  <Field
                    type="text"
                    name="businessName"
                    placeholder="Enter your business name"
                  />
                </div>
              </div>
              <div className="options-col-half">
                <div className="options-col-inner">

                </div>
              </div>
            </div>   

            <div className="options-row">        
              <div className="options-col-inner">
                <div className="paymentMethodSetupContainer">
                  <CardElement ref={card} />
                </div>
              </div>
            </div>

            {/*<h2 className="registerForm-cta-heading">Confirm payment.</h2>
            <p className="registerForm-cta-paragraph">Upon clicking confirm, your selected payment card will be charged <strong>$99</strong> as a standard initilization fee. By clicking confirm, you agree to our terms and conditions.</p>
            <div className="browse-cart">
              <span className="item-cost">$99 support core initialization <b>x1</b></span>
            </div>*/}      
            {paymentFailedStatus == false ?
            <>
              <div className="options-row">        
                <div className="options-col-inner">
                  <h2>Confirm card.</h2>
                  <p>Upon clicking confirm, your selected payment card will be charged every seven days for all leads generated by our support agents. By clicking confirm, you agree to our terms and conditions.</p>
                  <div className="browse-cart">
                    <span className="item-cost">Support core initialization <b>x1</b> - <b>($0)</b></span>
                  </div> 
                  <button disabled={buttonDisable} className="ec-button" type="submit"> Confirm payment</button>
                </div>
              </div>
            </>
            :
            <>
            <div className="options-row">        
              <div className="options-col-inner">
                <h2>Confirm payment method addition</h2>
                <p>Upon clicking confirm, your selected payment method will be assigned as the default payment method for your account. All associated live core instances that you own under this account will be charged from this card going forward. By clicking confirm, you agree to our terms and conditions.</p>
                <button disabled={buttonDisable} className="ec-button" type="submit"> Confirm payment method addition</button>
              </div>
            </div>
            </>
            }
      </div>

            </Form>
    </Formik>
    </div>
    </div>

    </div>

  </div>
  );
}

export default CompleteRegistration;
